import { PLANNING } from "@/data/planning";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { PreviewCard } from "@/components/cards/PreviewCard";
import { CTASection } from "@/components/common/CTASection";
import { IMG } from "@/data/images";

export default function PlanIndex() {
  return (
    <>
      <PageHero
        overline="Plan Your Visit"
        title="Plan the Perfect Colosseum Visit"
        subtitle="Opening hours, the best times to go, how to get there and everything you need for a smooth, stress-free day."
        image={IMG.fountainPeople}
        breadcrumbs={[{ label: "Plan Your Visit" }]}
      />

      <section className="container-wide py-14 md:py-20">
        <SectionHeading
          overline="Practical essentials"
          title="Everything you need to know before you go"
          description="Clear, scannable guides covering logistics, timing and on-the-day practicalities."
        />
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PLANNING.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.07}>
              <PreviewCard
                to={`/plan/${p.slug}`}
                image={p.heroImage}
                title={p.title}
                text={p.subtitle}
                testId={`plan-card-${p.slug}`}
              />
            </Reveal>
          ))}
        </div>
      </section>

      <div className="container-wide pb-20">
        <CTASection />
      </div>
    </>
  );
}
